<template>
  <v-dialog :model-value="open" max-width="500" persistent>
    <v-card class="custom-dialog-card">
      <v-card-title class="d-flex align-center justify-space-between pb-0">
        <div class="d-flex align-center">
          <v-icon color="primary" size="28" class="mr-2">mdi-magnify</v-icon>
          <span class="text-h6 font-weight-bold">Buscar {{ rotaBusca }}</span>
        </div>
        <v-btn icon flat @click="fecharDialog" class="close-btn" title="Fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div class="busca-fixa">
        <v-card-text class="pb-0 pt-3">
          <v-text-field
            v-model="termoBusca"
            label="Digite para buscar"
            clearable
            @keyup.enter="iniciarBusca"
            @click:append-inner="iniciarBusca"
          />
          <v-btn
            color="primary"
            block
            class="mb-3"
            :loading="loading"
            @click="iniciarBusca"
          >
            Buscar
          </v-btn>
          <v-alert
            v-if="erro"
            type="info"
            color="#e3f0ff"
            text
            border="start"
            class="mb-2 busca-alert"
            icon="mdi-alert-circle"
          >
            <span class="text-blue-darken-2">{{ erro }}</span>
          </v-alert>
        </v-card-text>
      </div>
      <v-card-text class="busca-scroll pt-0">
        <v-list v-if="data.length > 0 && buscaRealizada || exibirLista">
          <v-list-item
            v-for="item in data"
            :key="item.id || item.codcliente || item.codmunicipioibge || item.codigo"
            @click="selecionar(item)"
            class="busca-item"
            rounded
          >
            <!-- MUNICÍPIOS -->
            <template v-if="rotaBusca === 'municipios'">
              <v-list-item-title>
                {{ item.nome_municipio }}
              </v-list-item-title>
              <v-list-item-subtitle>
                Código IBGE: {{ item.codmunicipioibge }}
                <span v-if="item.sigla_uf">| UF: {{ item.sigla_uf }}</span>
              </v-list-item-subtitle>
            </template>

            <!-- CLIENTES -->
            <template v-else-if="rotaBusca === 'clientes'">
              <v-list-item-title>
                {{ item.razao_social || item.nome || item.cnpj_cpf || item.id }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.cnpj_cpf">
                {{ item.cnpj_cpf }}
              </v-list-item-subtitle>
            </template>

            <!-- PRODUTOS -->
            <template v-else-if="rotaBusca === 'produtos'">
              <v-list-item-title>
                {{ item.nome }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.descricao }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Código: {{ item.codproduto }}
              </v-list-item-subtitle>
            </template>

            <!-- OUTROS -->
            <template v-else>
              <v-list-item-title>
                {{ item.nome || item.descricao || item.id }}
              </v-list-item-title>
            </template>
          </v-list-item>
        </v-list>
        <div v-else-if="!loading && buscaRealizada">
          <v-alert
            type="info"
            class="busca-alert"
            border="start"
            icon="mdi-magnify-remove-outline"
            color="#e3f0ff"
            text
            dense
          >
            <span class="text-blue-darken-2">Nenhum resultado encontrado.</span>
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="fecharDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";

export default {
  props: {
    rotaBusca: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    exibirLista: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    termoBusca: "",
    loading: false,
    data: [],
    erro: "",
    buscaRealizada: false,
    todosDados: [],
  }),
  watch: {
    open(val) {
      if (val) {
        this.termoBusca = "";
        this.data = [];
        this.erro = "";
        this.buscaRealizada = false;
        this.todosDados = [];
        this.carregarTodos();
      }
    },
  },
  methods: {
    ...mapActions(['triggerFeedback']),
    async carregarTodos() {
      this.loading = true;
      this.erro = "";
      try {
        const response = await api.get(`/${this.rotaBusca}/`);
        this.todosDados = Array.isArray(response.data) ? response.data : [];
        this.data = this.todosDados;
      } catch (error) {
        this.erro = "Erro ao carregar dados.";
        this.triggerFeedback({
          message: 'Ocorreu um erro ao carregar os dados!',
          color: 'error',
          icon: 'mdi-alert-circle'
        });
      }
      this.loading = false;
    },
    iniciarBusca() {
      if (!this.termoBusca) {
        this.erro = "Digite um termo para buscar.";
        this.data = this.todosDados;
        this.buscaRealizada = false;
        return;
      }
      this.erro = "";
      const termo = this.termoBusca.toLowerCase();

      if (this.rotaBusca === "municipios") {
        this.data = this.todosDados.filter(item =>
          (item.nome_municipio && item.nome_municipio.toLowerCase().includes(termo)) ||
          (item.sigla_uf && item.sigla_uf.toLowerCase().includes(termo)) ||
          (item.codmunicipioibge && String(item.codmunicipioibge).includes(termo))
        );
      } else if (this.rotaBusca === "clientes") {
        this.data = this.todosDados.filter(item =>
          (item.razao_social && item.razao_social.toLowerCase().includes(termo)) ||
          (item.nome && item.nome.toLowerCase().includes(termo)) ||
          (item.cnpj_cpf && item.cnpj_cpf.toLowerCase().includes(termo)) ||
          (item.id && String(item.id).includes(termo)) ||
          (item.codcliente && String(item.codcliente).includes(termo))
        );
      } else {
        this.data = this.todosDados.filter(item =>
          (item.nome && item.nome.toLowerCase().includes(termo)) ||
          (item.descricao && item.descricao.toLowerCase().includes(termo)) ||
          (item.id && String(item.id).includes(termo)) ||
          (item.codigo && String(item.codigo).includes(termo))
        );
      }
      this.buscaRealizada = true;
    },
    fecharDialog() {
      this.$emit("update:open", false);
    },
    selecionar(item) {
      this.$emit("selecionado", item);
      this.fecharDialog();
    },
  },
};
</script>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 0 !important;
}
.close-btn {
  margin-right: -8px;
  margin-top: -8px;
}
.busca-fixa {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  border-radius: 18px 18px 0 0;
}
.busca-scroll {
  overflow-y: auto;
  max-height: 48vh;
  padding-bottom: 8px;
}
.busca-item {
  cursor: pointer;
  transition: background 0.18s;
}
.busca-item:hover {
  background: #f0f4ff;
}
.busca-alert {
  background: #e3f0ff !important;
  color: #1976d2 !important;
  border-left: 4px solid #1976d2 !important;
  font-size: 1rem;
  font-weight: 500;
  box-shadow: none;
}
</style>
